import { render, staticRenderFns } from "./CommissionTypeColumn.vue?vue&type=template&id=6fb4452a&scoped=true&"
import script from "./CommissionTypeColumn.vue?vue&type=script&lang=js&"
export * from "./CommissionTypeColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb4452a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
